// Claves placeholder: confirmar nombres reales con el equipo de contenido/CMS antes de producción.
export const HBO_ACTIVATE_CODE_TRANSLATION_KEYS = {
  TITLE_PART_1: { key: 'activahbomax_vinculacion_texto_titulo_parte1', length: 28 },
  TITLE_PART_2: { key: 'activahbomax_vinculacion_texto_titulo_parte2', length: 28 },
  ERROR_INCORRECT_CODE: { key: 'activahbomax_vinculacion_texto_parrafo_codigoincorrecto', length: 50 },
  ERROR_EXPIRED_CODE: { key: 'activahbomax_vinculacion_texto_parrafo_codigoexpirado', length: 50 },
  CONTINUE_LABEL: { key: 'activahbomax_vinculacion_boton_continuar'},
};

export const HBO_ACTIVATION_MODAL_TRANSLATION_KEYS = {
  TITLE: { key: 'activahbomax_modal1_texto_titulo', length: 84 },
  //DESCRIPTION: { key: 'Hbo_ActivacionModal_Descripcion' },
  PRIMARY_LABEL: { key: 'activahbomax_modal1_boton_texto_activalo', length: 22 },
  SECONDARY_LABEL: { key: 'activahbomax_modal1_boton_texto_despues', length: 22 },
};

export const HBO_ACTIVATE_OPTION_TRANSLATION_KEYS = {
  NAME_OPTION: {
    key: 'activahbomax_menuavatar_nodo_hbomax_texto_activar',
    length: 21,
  },
};

export const HBO_PROMOTION_MODAL_TRANSLATION_KEYS = {
  TITLE_LINE_1: { key: 'activahbomax_modal2_texto_parrafo1' },
  TITLE_LINE_2: { key: 'activahbomax_modal2_texto_parrafo2' },
  TITLE_LINE_3: { key: 'activahbomax_modal2_texto_parrafo3' },
//  TITLE_LINE_4: { key: 'Hbo_PromocionModal_Titulo_Linea4' },
  DESCRIPTION_LINE_1: { key: 'activahbomax_modal2_texto_parrafo4' },
  DESCRIPTION_LINE_2: { key: 'activahbomax_modal2_texto_parrafo5' },
  DESCRIPTION_LINE_3: { key: 'activahbomax_modal2_texto_parrafo6' },
  PRIMARY_LABEL: { key: 'activahbomax_modal2_boton_texto_aceptar', length: 31 },
  SECONDARY_LABEL: { key: 'activahbomax_modal2_boton_texto_nomostrar', length: 31 },
};

export const HBO_PROMOTION_MODAL_MAX_LENGTHS = {
  TITLE_LINES: 158,
  DESCRIPTION_LINES: 86,
};

export const HBO_ERROR_MODAL_TRANSLATION_KEYS = {
  TITLE: { key: 'activahbomax_modalerror_texto_titulo', length: 22 },
  MESSAGE: { key: 'activahbomax_modalerror_texto_parrafo', length: 84 },
  CLOSE_LABEL: { key: 'activahbomax_modalerror_boton_texto_cerrar', length: 22 },
};

// Valor EXACTO que /services/user/v1/superhighlight debe incluir en su arreglo de
// respuesta para considerar la cuenta con suscripcion HBO activa. "no_suscripto_hbo" NO
// cuenta como suscripcion, aunque este presente en el mismo arreglo.
export const HBO_SUBSCRIPTION_MARKER = 'suscripto_hbo';

// Estados de GET /status en los que la cuenta todavia puede activar HBO Max: habilitan tanto
// la opcion del menu avatar como el module_version v8 de los servicios de CMS
export const HBO_ELIGIBLE_ACTIVATION_STATUSES = ['unlinked', 'pending'];
